import {getDepartments, getTreeDepartments} from "@/api/departments";
import Vue from "vue";

/** treeDepartments
 * sortArray
 * recursionArrayObject
 */
// Sort
function sortArray (array) {
  array.sort((a, b) => {
    if (a.children?.length > 0 && b.children?.length === 0) {
      return -1
    }
    return 0
  })

  return array
}

// Рекурсия
function recursionArrayObject (array) {
  sortArray(array)

  for (let subObj of Object.values(array)){
    if (subObj.children?.length) {
      sortArray(subObj.children)
      recursionArrayObject(subObj.children)
    }
  }

 return array
}

export default {
  namespaced: true,
  state: {
    departments: [],
    treeDepartments: [],
    treeDepartmentsLoading: true,
  },
  actions: {
    getDepartments({ commit }) {
      getDepartments().then((res) => {
        const data = res.data.map(item => {
          item.isActive = false
          return item
        })
        commit("SET_DEPARTMENTS", data)
      });
    },

    getTreeDepartments({ commit }, params) {
      commit("SET_TREE_DEPARTMENTS_LOADING", true);

      params.trashed = params?.trashed || null
      getTreeDepartments(params)
        .then(res => {
          const data = recursionArrayObject(res)
          commit("SET_TREE_DEPARTMENTS", data);
        })
        .finally(() => commit("SET_TREE_DEPARTMENTS_LOADING", false));
    },

    clearTree({ commit }) {
      commit("CLEAR_TREE_DEPARTMENTS")
    },

    setActiveEl({ commit }, id) {
      commit("SET_IS_ACTIVE_TREE", id)
    }
  },
  mutations: {
    SET_DEPARTMENTS(state, departments) {
      state.departments = departments;
    },
    ADD_DEPARTMENTS(state, department) {
      state.departments.push(department);
    },
    DELETE_DEPARTMENTS(state, depId) {
      state.departments = state.departments.filter((dep) => dep.id !== depId);
    },
    SET_TREE_DEPARTMENTS(state, tree) {
      state.treeDepartments = tree;
    },
    SET_TREE_DEPARTMENTS_LOADING(state, loading) {
      state.treeDepartmentsLoading = loading;
    },
    UPDATE_DEPARTMENT(state, department) {
      const depIndex = state.departments.findIndex(
        (dep) => dep.id === department.id
      );
      if (depIndex !== -1) Vue.set(state.departments, depIndex, department);
    },

    CLEAR_TREE_DEPARTMENTS (state) {
      state.treeDepartments = []
    }
  },
  getters: {
    getDepartmentById(state) {
      return (id) => state.departments.find((dep) => dep?.id === id);
    },
    getDepartmentNameById(state) {
      return (id) => state.departments.find((dep) => dep?.id === id)?.name || "";
    },

    getParentDepartmentById(state) {
      return (parentId) =>
       state.departments.find((dep) => dep?.id === parentId) || null;
    },

    treeDepartments(state) {
      return state.treeDepartments
    },

    getDepartments(state) {
      return state.departments
    }
  },
};
